import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isUserLoggedIn } from "../utils/helper";
import Header from "../components/header/banner/index";
import CookiesBanner from "../components/cookies/CookiesBanner";
import SessionTimeout from "../components/session-timeout/SessionTimeout";

const ProtectedRoutes = (props) => {
  const auth = isUserLoggedIn();
  const location = useLocation();
  const partnerID =
    localStorage.getItem("partnerID") ||
    location?.pathname?.split("/")[2]?.replace(/_/g, " ");

  return auth ? (
    <>
      <Header />
      <SessionTimeout />
      <CookiesBanner />
      <Outlet />
    </>
  ) : partnerID ? (
    <Navigate to={`/login/${partnerID}`} />
  ) : (
    <Navigate to={`/login`} />
  );
};

export default ProtectedRoutes;
